import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bookingCallingReception } from 'repositories/BerthApi/bookingCallingReception'
import { berthKeys, bookingKeys } from 'repositories/queryKeys'

export function useCallingReception() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: bookingCallingReception,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: berthKeys.managements() })
      queryClient.invalidateQueries({ queryKey: bookingKeys.unassigned() })
    },
  })
}
